// router/index.js
import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '../layout/mainApp/index.vue'; // 你的layout组件

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		component: Layout,
		children: [
			{
				path: '',
				name: 'home',
				meta: { title: '教育版·首页' },
				component: () => import('../views/home/index.vue'),
			},
			{
				path: 'list',
				name: 'list',
				meta: { title: '教育版·列表页' },
				component: () => import('../views/list/index.vue'),
			},
			{
				path: 'Ebriefing',
				name: 'Ebriefing',
				meta: { title: '教育版·电子简报' },
				component: () => import('../views/Ebriefing/index.vue'),

			},
			{
				path: 'iap',
				name: 'iap',
				meta: { title: '教育版·课程思政案例库' },
				component: () => import('../views/list/iap/index.vue'),

			}
			,
			{
				path: 'about',
				name: 'about',
				meta: { title: '教育版·产品介绍' },
				component: () => import('../views/about/index.vue'),

			}
		]
	}
];

const router = new VueRouter({
	routes,
	mode: 'history',
	base: '/',
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 };
		}
	}
});

router.afterEach((to, from) => {
   if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  
  // 【关键修复】每次路由跳转后，强制检查并恢复 body 的滚动能力
  // 防止因为 Nav 菜单逻辑导致 body 被锁死
  Vue.nextTick(() => {
    document.body.style.overflow = ''; 
    document.documentElement.style.overflow = '';
    
    // 确保回到顶部（针对 window 滚动模式）
    window.scrollTo(0, 0);
  });
});


export default router;
